import { useMemo } from "react";

/**
 * 
 * @param {*} props
 * detail : string => object key of _details the field is part of
 * index : int => since _details is an array. This tells us to which this field belongs to
 * @returns 
 */
export const TextField = (props) =>{
    const {fieldName, fieldConfig, onChange, detail, index, ...prop} = props;
    const handleFieldChange= (value, e) =>{
        if(onChange)
            onChange(value, fieldName, {fieldConfig, detail, index, e});
    }
    
    const settings = useMemo(() => {
        return {
            Mandatory : false, 
            Type : "string",
            Value : null,
            ...fieldConfig
        }
    }, [fieldConfig])
    return (
        <>
        <input 
          type= {settings.Type}
          name={fieldName}
          required={settings.Mandatory}
          key={fieldName}
          defaultValue={settings.Value}
          {...prop}
          onChange={(e) => {
            handleFieldChange(e.target.value, e);
          }}
          placeholder={settings.Trans?.Placeholder || props.placeholder || ""}></input>
          </>
    )
}